var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.686 9.07619C22.6961 9.5321 22.4485 9.95515 22.0438 10.162L8.15856 17.3146C7.83463 17.4811 7.45075 17.4894 7.11906 17.3359C6.78736 17.1824 6.54468 16.8863 6.46028 16.5302L5.34362 11.8554L1.62483 11.4152C1.13949 11.3596 0.738047 11.0091 0.613861 10.5351C0.489674 10.0612 0.672439 9.56142 1.06873 9.27349L3.57858 7.44998C3.69867 7.36273 3.84547 7.32488 3.99143 7.34268L13.1382 8.38491C13.4539 8.42162 13.7407 8.20404 13.79 7.89303C13.8392 7.58202 13.6397 7.28208 13.3311 7.21727L3.4695 5.05227L2.87045 1.43721C2.79835 1.00337 2.96826 0.568008 3.31598 0.301615C3.6637 0.0352229 4.12918 -0.0185751 4.5288 0.158957L21.9864 8.0249C22.4029 8.21309 22.6728 8.62247 22.686 9.07619Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSharp);
export default __webpack_public_path__ + "static/media/send-sharp.0c225f358f1f9ef4acd24aabfaa70677.svg";
export { ForwardRef as ReactComponent };